/* new_option_selection.js */
function floatToString(t, e) {
    var o = t.toFixed(e).toString();
    return o.match(/^\.\d+/) ? "0" + o : o
}
if ("undefined" == typeof Shopify)
    var Shopify = {};
Shopify.each = function(t, e) {
    for (var o = 0; o < t.length; o++)
        e(t[o], o)
}
,
Shopify.map = function(t, e) {
    for (var o = [], i = 0; i < t.length; i++)
        o.push(e(t[i], i));
    return o
}
,
Shopify.arrayIncludes = function(t, e) {
    for (var o = 0; o < t.length; o++)
        if (t[o] == e)
            return !0;
    return !1
}
,
Shopify.uniq = function(t) {
    for (var e = [], o = 0; o < t.length; o++)
        Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
    return e
}
,
Shopify.isDefined = function(t) {
    return "undefined" == typeof t ? !1 : !0
}
,
Shopify.getClass = function(t) {
    return Object.prototype.toString.call(t).slice(8, -1)
}
,
Shopify.extend = function(t, e) {
    function o() {}
    o.prototype = e.prototype,
    t.prototype = new o,
    t.prototype.constructor = t,
    t.baseConstructor = e,
    t.superClass = e.prototype
}
,
Shopify.locationSearch = function() {
    return window.location.search
}
,
Shopify.locationHash = function() {
    return window.location.hash
}
,
Shopify.replaceState = function(t) {
    window.history.replaceState({}, document.title, t)
}
,
Shopify.urlParam = function(t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "))
}
,
Shopify.newState = function(t, e) {
    var o;
    return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e,
    o + Shopify.locationHash()
}
,
Shopify.setParam = function(t, e) {
    Shopify.replaceState(Shopify.newState(t, e))
}
,
Shopify.Product = function(t) {
    Shopify.isDefined(t) && this.update(t)
}
,
Shopify.Product.prototype.update = function(t) {
    for (property in t)
        this[property] = t[property]
}
,
Shopify.Product.prototype.optionNames = function() {
    return "Array" == Shopify.getClass(this.options) ? this.options : []
}
,
Shopify.Product.prototype.optionValues = function(t) {
    if (!Shopify.isDefined(this.variants))
        return null;
    var e = Shopify.map(this.variants, function(e) {
        var o = "option" + (t + 1);
        return void 0 == e[o] ? null : e[o]
    });
    return null == e[0] ? null : Shopify.uniq(e)
}
,
Shopify.Product.prototype.getVariant = function(t) {
    var e = null;
    return t.length != this.options.length ? e : (Shopify.each(this.variants, function(o) {
        for (var i = !0, r = 0; r < t.length; r++) {
            var n = "option" + (r + 1);
            o[n] != t[r] && (i = !1)
        }
        return 1 == i ? void (e = o) : void 0
    }),
    e)
}
,
Shopify.Product.prototype.getVariantById = function(t) {
    for (var e = 0; e < this.variants.length; e++) {
        var o = this.variants[e];
        if (t == o.id)
            return o
    }
    return null
}
,
Shopify.money_format = "$",
Shopify.formatMoney = function(t, e) {
    function o(t, e) {
        return "undefined" == typeof t ? e : t
    }
    function i(t, e, i, r) {
        if (e = o(e, 2),
        i = o(i, ","),
        r = o(r, "."),
        isNaN(t) || null == t)
            return 0;
        t = (t / 100).toFixed(e);
        var n = t.split(".")
          , a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i)
          , s = n[1] ? r + n[1] : "";
        return a + s
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = ""
      , n = /\{\{\s*(\w+)\s*\}\}/
      , a = e || this.money_format;
    switch (a.match(n)[1]) {
    case "amount":
        r = i(t, 2);
        break;
    case "amount_no_decimals":
        r = i(t, 0);
        break;
    case "amount_with_comma_separator":
        r = i(t, 2, ".", ",");
        break;
    case "amount_no_decimals_with_comma_separator":
        r = i(t, 0, ".", ",")
    }
    return a.replace(n, r)
}
,
Shopify.OptionSelectors = function(t, e) {
    return this.selectorDivClass = "selector-wrapper",
    this.selectorClass = "single-option-selector",
    this.variantIdFieldIdSuffix = "-variant-id",
    this.variantIdField = null,
    this.historyState = null,
    this.selectors = [],
    this.domIdPrefix = t,
    this.product = new Shopify.Product(e.product),
    this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function() {}
    ,
    this.replaceSelector(t),
    this.initDropdown(),
    e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)),
    !0
}
,
Shopify.OptionSelectors.prototype.initDropdown = function() {
    var t = {
        initialLoad: !0
    }
      , e = this.selectVariantFromDropdown(t);
    if (!e) {
        var o = this;
        setTimeout(function() {
            o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t)
        })
    }
}
,
Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(t) {
    this.selectors[0].element.onchange(t)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(t) {
    var e = this.selectVariantFromParams(t);
    e || this.selectVariantFromDropdown(t)
}
,
Shopify.OptionSelectors.prototype.replaceSelector = function(t) {
    var e = document.getElementById(t)
      , o = e.parentNode;
    Shopify.each(this.buildSelectors(), function(t) {
        o.insertBefore(t, e)
    }),
    e.style.display = "none",
    this.variantIdField = e
}
,
Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(t) {
    var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
    if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),
    !e)
        return !1;
    var o = e.value;
    return this.selectVariant(o, t)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParams = function(t) {
    var e = Shopify.urlParam("variant");
    return this.selectVariant(e, t)
}
,
Shopify.OptionSelectors.prototype.selectVariant = function(t, e) {
    var o = this.product.getVariantById(t);
    if (null == o)
        return !1;
    for (var i = 0; i < this.selectors.length; i++) {
        var r = this.selectors[i].element
          , n = r.getAttribute("data-option")
          , a = o[n];
        null != a && this.optionExistInSelect(r, a) && (r.value = a)
    }
    return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e),
    !0
}
,
Shopify.OptionSelectors.prototype.optionExistInSelect = function(t, e) {
    for (var o = 0; o < t.options.length; o++)
        if (t.options[o].value == e)
            return !0
}
,
Shopify.OptionSelectors.prototype.insertSelectors = function(t, e) {
    Shopify.isDefined(e) && this.setMessageElement(e),
    this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
    var o = document.getElementById(t);
    Shopify.each(this.buildSelectors(), function(t) {
        o.appendChild(t)
    })
}
,
Shopify.OptionSelectors.prototype.getQuickList = function() {
  var ret  = [];
  for(var off = 0 ; off < this.product.variants.length; off++){    
    var cv = this.product.variants[off];
    
    var co1 = ret[cv.option1];
    if(co1 === undefined){
      co1 =[];
      ret[cv.option1] = co1;    
    }
    var co2 = co1[cv.option2];
    if(co2 === undefined){
      co2 = [];
      co1[cv.option2] = co2;
    }   
    var co3 = co2[cv.option3];
    if(co3 == undefined){
      co3 = [cv.option3];
      co2[cv.option3] = co3;
    }        
  }
  return ret;
  
},
Shopify.OptionSelectors.prototype.onSelectionChanged = function(e, all,ql){  
  showIpadDescription();
  var selector = e.info;
  var qlE = ql[ $(all[0].element).val()];
               
  for(var i = 1; i < 3 && i < all.length ;i++){
    //qlE = qlE[$(all[i].element).val()];
   	if(i < selector.index){
    	qlE = qlE[$(all[i].element).val()];
    }else{
      var selObj = $(all[i].element);
      var crtSele = selObj.val();
      var allOpt = selObj.children("option");
      var selOk = false;
      var toSel = null;
      var ovals = this.product.optionValues(i)
      for(var oo = 0; oo < ovals.length  ;oo++){        
        var ovo = ovals[oo];
        var crtAllOpt = selObj.children("option");
        if(crtAllOpt.length <= oo ||$(crtAllOpt[oo]).val() != ovo)
        {
           	var n = document.createElement("option");
           	n.value = ovo;
        	n.innerHTML = ovo;
        	Shopify.OptionSelectors.insertChildAtIndex(selObj[0],n,oo);
        }
      }
      allOpt = selObj.children("option");
      for(;oo < allOpt.length;)
      {
         var so = $(allOpt[oo]);
         so.remove();
         allOpt = selObj.children("option");
      }
      allOpt = selObj.children("option");
      for(var oo = 0; oo <  allOpt.length;oo++){    
        var so = $(allOpt[oo]);
        if(qlE[so.val()] === undefined){             
        	so.remove(); 
            allOpt = selObj.children("option");
            oo--;
        }else{          
          
          if(crtSele == so.val()){            
            selOk = true;         
            toSel = so;
          }else{
            if(toSel == null){
              toSel = so;
            }
          }
        }
      }     
      if(!selOk){
        if(toSel != null)
        {
                                
          //return;
        }                                
      }else{
        qlE = qlE[selObj.val()];
      }
      if(i==1){
         var crtClrSel = selObj.val();
        if(toSel != null){
          crtClrSel = toSel.val();
        }
        var allCaseBtns = $(".cstBtnSelector").children(".case_btn_ext");
        var actBtn = 0;
        allCaseBtns.each(function(e){                    
            var t = $(this);
            var oSel = selObj.children("option[value='"+t.attr("data-clr")+"']");
            var exists = oSel.length > 0 && !(oSel.css("display") =="none");
            if(exists){
              t.show();    
              activeColors++;        
            }else{
              t.hide();
            }
            if(t.attr("data-clr") == crtClrSel)
            {
              t.addClass("cst-btn-selected");
            }else{
              t.removeClass("cst-btn-selected");                
            }
           
         });      
        $(".description-case-type").removeClass("selected");
        $(".description-case-type[data-option='" +crtClrSel.toLowerCase() + "']").addClass("selected");
        $(".extra-description").addClass("extra-description-case-type");
        $(".extra-description[data-option='" +crtClrSel.toLowerCase() + "']").removeClass("extra-description-case-type");
        if(crtClrSel=="Impact")
        {
          var sel3= selObj.parents("div.select").find("select[data-option='option3']");
          sel3.attr("forceblack","true");          
        }
          
      }
      if(i==2){
        if(selObj.attr("forceblack") == "true"){
          
          sel3 = selObj;
          var toSelTmp = sel3.find("option[value='Black']");            
          if(toSelTmp){
            toSel = toSelTmp;
          }
          selObj.attr("forceblack","");
        }
        var crtClrSel = selObj.val();
        if(toSel != null){
          crtClrSel = toSel.val();
        }
        var allCaseClr = $(".clrSelector").children(".case_color");
        var activeColors = 0;
        allCaseClr.each(function(e){                    
          var t = $(this);
          var oSel = selObj.children("option[value='"+t.attr("data-clr")+"']");
          var exists = oSel.length > 0 && !(oSel.css("display") =="none");
          if(exists){
            t.show();    
            activeColors++;        
          }else{
            t.hide();
          }
          if(t.attr("data-clr") == crtClrSel)
          {
            t.addClass("case-selected");
          }else{
            t.removeClass("case-selected");                
          }
        });   
        var parWrap = selObj.parents(".selector-wrapper");
        if(activeColors > 1){
          parWrap.show();
        }else{
		 parWrap.hide();
        }
        var sel2 = $(".single-option-selector[data-option='option2']").val();
        if(!sel2) sel2 = "";
        $(".clrSelector").each(function(){
          var pw = $(this).parents(".selector-wrapper");
          var origSel = pw.find("select[data-option='option3']");
           if("impact" == sel2.toLowerCase()){                  
    	    	//pw.show();    
             	origSel.hide();
             	$(this).show();
             	
          	}else{
	            //pw.hide();
              	$(this).hide();
              	origSel.show();             	
          	}         
            
        });
        var sel2 = $(all[1].element);
        var crSel2 = sel2.val();
        $(".description-case-type").removeClass("selected");
        var allSel2 = $(".description-case-type[data-option='" +crSel2.toLowerCase() + "']").length;
        if(allSel2 > 1)
        {
          $(".description-case-type[data-option='" +crSel2.toLowerCase() + "'][data-option2='" +crtClrSel.toLowerCase() + "']").addClass("selected");
          
        }else{
          var allSel2 = $(".description-case-type[data-option='" +crSel2.toLowerCase() + "']").addClass("selected");
        }
        
        var allExtra = $(".extra-description[data-option='" +crSel2.toLowerCase() + "']").attr("data-option2");
        if(allExtra)
        {
          $(".extra-description").addClass("extra-description-case-type");
          $(".extra-description[data-option='" +crSel2.toLowerCase() + "'][data-option2='" +crtClrSel.toLowerCase() + "']").removeClass("extra-description-case-type");
        }
        else
        {
          $(".extra-description").addClass("extra-description-case-type");
          $(".extra-description[data-option='" +crSel2.toLowerCase() + "']").removeClass("extra-description-case-type");
        }
        
        
      }
        if(!selOk){          
          if(toSel != null){
            selObj.val(toSel.val());     
            selObj.change();  
            return;
          }
        }  
    }
  }
  
  
},
Shopify.OptionSelectors.insertChildAtIndex = function(el, child, index) {
  if (!index) index = 0
  if (index >= el.children.length) {
    el.appendChild(child)
  } else {
    el.insertBefore(child, el.children[index])
  }
}
Shopify.OptionSelectors.prototype.buildSelectors = function() {
  var  me= this;
  var ql = this.getQuickList();
    for (var t = 0; t < this.product.optionNames().length; t++) {
        var e = new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));
        e.element.disabled = !1;
        e.element.info = e;        
        $(e.element).change(function(){
              me.onSelectionChanged(this,me.selectors, ql);    
        }); 
      	if(t==1)
        {
          e.custom_swatch = new Shopify.ButtonOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t), e.element);
        }
        if(t== 2){
			e.custom_color = new Shopify.ColorOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t), e.element);
          	e.custom_color_mobile = new Shopify.ColorOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t), e.element);
        }
        this.selectors.push(e);
    }
    var o = this.selectorDivClass
      , i = this.product.optionNames()
      , r = Shopify.map(this.selectors, function(t) {
        var e = document.createElement("div");
        if (e.setAttribute("class", o),
        i.length > 1) {          	
            var r = document.createElement("label");
            r.htmlFor = t.element.id,
            r.innerHTML = t.name,
            e.appendChild(r)
            if(t.name.toLowerCase() == "phone case")
           	 $(r).addClass("selector-target-inactive");
        }
        e.appendChild(t.element);
        if(t.custom_swatch){
          //$(t.element).hide();
          $(t.element).addClass("selector-target-inactive");          
          e.appendChild(t.custom_swatch);
          //target.replace(new RegExp(/[^a-zA-Z0-9]/g, 'g'),"_");
          //e.appendChild($("<div class='description description-case-type' data-option='snap' ><p>ultra thin 1mm</p></div>")[0]);
          //e/.appendChild($("<div class='description description-case-type' data-option='tough' ><p>hard plastic transparent case</p></div>")[0]);
          //$(e).addClass("selector-target-active");
        }         
        if(t.custom_color){
          $(t.element).hide();
          e.appendChild(t.custom_color);
        //  $(e).addClass("selector-target-inactive");
        }         
        if( t.custom_color_mobile){
          var ei = document.createElement("div");           
          if (ei.setAttribute("class", o),
              i.length > 1) {
            var r = document.createElement("label");
            r.htmlFor = t.element.id,
              r.innerHTML = t.name,
              ei.appendChild(r);
          }
          $(ei).addClass("selector-target-active");
          ei.appendChild(t.custom_color_mobile);
          var parTrg = $("form[data-select-id='"+ me.domIdPrefix+"']").parent("div");            
         // Shopify.OptionSelectors.insertChildAtIndex(parTrg[0],ei,0);
        }
        
        return e;
    });
    return r
}
,
Shopify.OptionSelectors.prototype.selectedValues = function() {
    for (var t = [], e = 0; e < this.selectors.length; e++) {
        var o = this.selectors[e].element.value;
        t.push(o)
    }
    return t
}
,
Shopify.OptionSelectors.prototype.updateSelectors = function(t, e) {
    var o = this.selectedValues()
      , i = this.product.getVariant(o);
    i ? (this.variantIdField.disabled = !1,
    this.variantIdField.value = i.id) : this.variantIdField.disabled = !0,
    this.onVariantSelected(i, this, e),
    null != this.historyState && this.historyState.onVariantChange(i, this, e)
}
,
Shopify.OptionSelectorsFromDOM = function(t, e) {
    var o = e.optionNames || []
      , i = e.priceFieldExists || !0
      , r = e.delimiter || "/"
      , n = this.createProductFromSelector(t, o, i, r);
    e.product = n,
    Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e)
}
,
Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors),
Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(t, e, o, i) {
    if (!Shopify.isDefined(o))
        var o = !0;
    if (!Shopify.isDefined(i))
        var i = "/";
    var r = document.getElementById(t)
      , n = r.childNodes
      , a = (r.parentNode,
    e.length)
      , s = [];
    Shopify.each(n, function(t, r) {
        if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
            var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
            0 == e.length && (a = n.length - (o ? 1 : 0));
            var p = n.slice(0, a)
              , l = o ? n[a] : ""
              , c = (t.getAttribute("value"),
            {
                available: t.disabled ? !1 : !0,
                id: parseFloat(t.value),
                price: l,
                option1: p[0],
                option2: p[1],
                option3: p[2]
            });
            s.push(c)
        }
    });
    var p = {
        variants: s
    };
    if (0 == e.length) {
        p.options = [];
        for (var l = 0; a > l; l++)
            p.options[l] = "option " + (l + 1)
    } else
        p.options = e;
    return p
}
,
Shopify.ButtonOptionSelector = function(t, e, o, i, ext) {
    var idTarget = "#" + ext.id;//"#" + t.domIdPrefix;
  	var $ex = $(ext);
	var activeSwatchSel = $ex.val();
  	var cc = $("<div class='cstBtnSelector selector-target-active'>");
    for (var r = 0; r < i.length; r++) {
      var c= i[r];
      var exists = $ex.children("option[value='"+c+"']").length == 1;
      var cSel = activeSwatchSel == c ? "cst-btn-selected":"";
      var eDv = $("<div>").addClass("case_btn_ext");
      var myDv = $("<div>").text(c);
      eDv.append(myDv);
      cc.append(eDv);
      myDv.addClass("case_btn");
      eDv.addClass(cSel).attr("data-clr",c).attr("title",c).click(function(){
          var ct = $(this).attr("data-clr");
          $(idTarget).val(ct);
          $(idTarget).change();
        });     
      if(!exists){
        eDv.hide();
      }      
    }
  return cc[0];
},
Shopify.ColorOptionSelector = function(t, e, o, i, ext) {
    var idTarget = "#" + ext.id;//"#" + t.domIdPrefix;
  	var $ex = $(ext);
	var activeCaseColor = $ex.val();
  	var cc = $("<div class='clrSelector'>");
    for (var r = 0; r < i.length; r++) {
      var c= i[r];
      var exists = $ex.children("option[value='"+c+"']").length == 1;
      var cSel = activeCaseColor == c ? "case-selected":"";
      var myDv = $("<div>");
      cc.append(myDv.addClass("case_color").addClass(cSel).addClass(c.toLowerCase() + "_case_color").attr("data-clr",c).click(function(){
          var ct = $(this).attr("data-clr");
          $(idTarget).val(ct);
          $(idTarget).change();
        }));     
      if(!exists){
        myDv.hide();
      }
      
    }
  return cc[0];
},
Shopify.SingleOptionSelector = function(t, e, o, i) {
    
    this.multiSelector = t,
    this.values = i,
    this.index = e,
    this.name = o,
    this.element = document.createElement("select");
    for (var r = 0; r < i.length; r++) {      
        var n = document.createElement("option");
        n.value = i[r],
        n.innerHTML = i[r],
        this.element.appendChild(n)
    }
    return this.element.setAttribute("class", this.multiSelector.selectorClass),
    this.element.setAttribute("data-option", "option" + (e + 1)),
    this.element.id = t.domIdPrefix + "-option-" + e,
    this.element.onchange = function(o, i) {
        i = i || {},
        t.updateSelectors(e, i);
    }
    ,
    !0
}
,
Shopify.Image = {
    preload: function(t, e) {
        for (var o = 0; o < t.length; o++) {
            var i = t[o];
            this.loadImage(this.getSizedImageUrl(i, e))
        }
    },
    loadImage: function(t) {
        (new Image).src = t
    },
    switchImage: function(t, e, o) {
        if (t && e) {
            var i = this.imageSize(e.src)
              , r = this.getSizedImageUrl(t.src, i);
            o ? o(r, t, e) : e.src = r
        }
    },
    imageSize: function(t) {
        var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
        return null != e ? e[1] : null
    },
    getSizedImageUrl: function(t, e) {
        if (null == e)
            return t;
        if ("master" == e)
            return this.removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != o) {
            var i = t.split(o[0])
              , r = o[0];
            return this.removeProtocol(i[0] + "_" + e + r)
        }
        return null
    },
    removeProtocol: function(t) {
        return t.replace(/http(s)?:/, "")
    }
},
Shopify.OptionSelectors.HistoryState = function(t) {
    this.browserSupports() && this.register(t)
}
,
Shopify.OptionSelectors.HistoryState.prototype.register = function(t) {
    window.addEventListener("popstate", function(e) {
        t.selectVariantFromParamsOrDropdown({
            popStateCall: !0
        })
    })
}
,
Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(t, e, o) {
    this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id))
}
,
Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
    return window.history && window.history.replaceState
}
;


function showIpadDescription(){
   if(meta.product.type == "iPad Case" || meta.product.type == 'iPad Case Breed' || meta.product.type == "Macbook Case" ){
      $(".description-case-type").removeClass("selected");
      var sel1 = $(".single-option-selector[data-option='option1']").val();
      $(".description-case-type[single-option-value='" +sel1 + "']").addClass("selected");
    }
}